import React from "react";
import "./Kostnadsfri.css";
import partnerImg from "../../utils/images/seoimages/partner.webp";

const Kostnadsfri = ({ vad, text, mainquery }) => {
  return (
    <div className="kostnadfri-section-container">
      <div className="kostnadfri-items">
        <div className="kostnadfri-image-placeholder">
          <img
            src={partnerImg}
            alt="Team som diskuterar vid ett konferensbord"
          />
        </div>
        <div className="kostnadfri-text">
          <h2 className="heading">
            <span className=" orange-text">Partner </span>
            <span className="white-text">med oss</span>
          </h2>
          <h3>och få hjälp med {mainquery}</h3>
          <p>
            Vi erbjuder en <b> kostnadsfri konsultation </b> för att diskutera
            hur vi kan hjälpa dig med {mainquery}. Konsultationen tar cirka 45
            minuter och du får en skräddarsydd offert på plats. Vi erbjuder en
            kostnadsfri konsultation för att ge dig en tydlig och rättvis
            bedömning av ditt {text}. Oavsett om det handlar om webbutveckling,
            SEO, eller digital marknadsföring, är vår professionella tjänst
            designad för att ge dig en transparent och detaljerad
            rekommendation. Kontakta oss idag för att boka din{" "}
            <b> kostnadsfria konsultation </b> och ta nästa steg mot att
            förbättra din online-närvaro.
          </p>
          <div>
          <a href="./konsultation" className="get-started-btn1">
            Boka kostnadfri konsultation{" "}
          </a>
        </div>
        </div>
       
      </div>
    </div>
  );
};

export default Kostnadsfri;
